import React from 'react';

export interface LinkProps {
    href: string;
    target?: '_blank' | '_self' | '_parent' | '_top';
    rel?: string;
    children: React.ReactNode;
    className?: string;
    showRightBorder?: boolean;
    showLeftBorder?: boolean;
    padding?: boolean;
    color?: 'default' | 'dimmed';
    fontSize?: 'sm' | 'base';
}

const LinkText: React.FC<LinkProps> = ({
    children,
    href,
    target = '_self',
    rel,
    className = '',
    showRightBorder = false,
    showLeftBorder = false,
    padding = false,
    color = 'default',
    fontSize = 'base',
}) => {
    const borderClasses = [
        showLeftBorder && 'border-l border-[var(--malachite-text-dimmed)]',
        showRightBorder && 'border-r border-[var(--malachite-text-dimmed)]',
    ]
        .filter(Boolean)
        .join(' ');

    const paddingClasses = padding ? 'px-[10px]' : '';

    const colorClasses =
        color === 'dimmed'
            ? 'text-[var(--malachite-text-dimmed)]'
            : 'text-[var(--malachite-text-link-foreground)] hover:text-[var(--malachite-text-link-foreground-hover)]';

    const fontSizeClasses = fontSize === 'sm' ? 'text-[13px]' : '';

    return (
        <a
            href={href}
            target={target}
            rel={rel}
            className={`no-underline cursor-pointer transition-colors duration-200 ease-in-out ${colorClasses} ${borderClasses} ${paddingClasses} ${fontSizeClasses} ${className}`}
        >
            {children}
        </a>
    );
};

export default LinkText;
